<template>
  <div>
    <el-dialog
      custom-class="demand-selector-dialog"
      :title="$t('wechat.bind')"
      :visible.sync="modalShow"
      :append-to-body="true"
      @closed="onModalHide"
      width="600px"
    >
      <Empty v-if="modalLoading" :loading="modalLoading"></Empty>
      <div class="dialog-content" v-else>
        <table>
          <tr>
            <td :colspan="2">
              <div id="qrcode" ref="qrcode"></div>
              <div>{{$t('wechat.sacnCode')}}</div>
            </td>
          </tr>
        </table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import QRCode from "qrcodejs2";
import { getWxBindUrl } from "@/api/login";
export default {
  name: "BindWechat",
  computed: {
    ...mapGetters(["name"]),
  },
  data() {
    return {
      modalShow: false,
      modalLoading: false,
      url: "",
    };
  },
  methods: {
    qrcode() {
      try {
        document.getElementById("qrcode").innerHTML = "";
        let qrcode = new QRCode(this.$refs.qrcode, {
          width: 150,
          height: 150,
          text: this.url,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
        // console.log(qrcode)
      } catch (error) {
        console.log(error);
      }
    },
    async onModalShow() {
      // 获取绑定链接
      if (!this.url) {
        let res = await getWxBindUrl();
        if (res) {
          this.url = res.data;
        }
      }
      this.modalShow = true;
      this.modalLoading = true;
      try {
        this.$nextTick(function () {
          this.qrcode();
        });

        this.modalLoading = false;
      } catch (error) {
        this.modalShow = false;
        this.modalLoading = false;
        this.$message.error(this.$t("generalData.warning.loadFail"));
      }
    },
    onModalHide() {
      this.modalShow = false;
      localStorage[`${this.name}-${document.title}-wechat`] = 1;
      this.$store.commit('SET_WXMODEL',false)
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  text-align: center;
  td {
    padding: 15px 0;
    a:hover {
      color: #0062ff;
    }
  }
}
</style>

<style lang="scss">
#qrcode {
  margin-bottom: 10px;
  img {
    margin: 0 auto !important;
  }
}
</style>